// extracted by mini-css-extract-plugin
export default {"wrapper":"ScrollTopArrow_wrapper__uB1aH","fadeIn":"ScrollTopArrow_fadeIn__R2nsv"};